// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"b790d0ea","270":"f75e0fa5","354":"bcc0bbb0","366":"2433f591","453":"2f003379","482":"b48ed95c","537":"ae646d9a","657":"85d76c76","666":"0beb3bc1","742":"9ac7b234"}[chunkId] + ".chunk.js";
};